'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Button from 'ui/src/components/Button';

import type { SnackbarStatesType } from 'ui/src/components/Snackbar';
import Snackbar from 'ui/src/components/Snackbar';
import { ThemeEnum } from 'ui/src/components/Theme';

import CheckIcon from 'ui/src/icons/CheckIcon';

import { setClientCookie, getClientCookie } from 'utilities/src/cookiesUtils';

const COOKIE_NAME = 'cookie_policy_consent';

function CookieBar() {
  const [cookieBarState, setCookieBarState] = useState<SnackbarStatesType>('Loading');

  useEffect(() => {
    const hasCookie = getClientCookie(COOKIE_NAME);

    setCookieBarState(hasCookie ? 'Closed' : 'Visible');
  }, []);

  const handleClick = () => {
    setClientCookie(COOKIE_NAME, '1', 365);

    setCookieBarState('Closed');
  };

  return (
    <Snackbar
      float
      variant="Primary"
      size="Full"
      state={cookieBarState}
      customButton={
        <Button<ThemeEnum.Site>
          icon={CheckIcon}
          variant="Primary"
          onClick={handleClick}
          variantColor="Green"
          size="Small"
          classes="pointer"
        >
          GOT IT
        </Button>
      }
    >
      <span className="mdS:w-full block font-normal">
        By continuing to use this site, you agree to our{' '}
        <Link
          href="https://www.bairesdev.com/privacy-policy/"
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          cookie policy
        </Link>{' '}
        and{' '}
        <Link
          href="https://www.bairesdev.com/privacy-policy/"
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          privacy policy
        </Link>
        .
      </span>
    </Snackbar>
  );
}

export default CookieBar;
